import { render, staticRenderFns } from "./hotOliver.vue?vue&type=template&id=051f32cb&scoped=true"
import script from "./hotOliver.vue?vue&type=script&lang=js"
export * from "./hotOliver.vue?vue&type=script&lang=js"
import style0 from "./hotOliver.vue?vue&type=style&index=0&id=051f32cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f32cb",
  null
  
)

export default component.exports